import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { PanelGroup } from 'react-bootstrap';
import * as clevertapCustomersLoyalty from 'clevertap/customers/loyalty';
import styles from './Program.css';
import WrappedPanel from './WrappedPanel';
import ProgramType from './ProgramType';
import Reward from './Reward';
import ProgramConfiguration from './ProgramConfiguration';
import CannotReviewModal from './CannotReviewModal';

class Program extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '1',
      isRewardVisited: props.isAccordionEnabled,
      isConfigurationVisited: props.isAccordionEnabled,
      showModalAtFirst: !props.isAccordionEnabled,
      showModal: false,
    };
  }

  componentDidMount() {
    if (this.props.parentComponent === 'Create') {
      clevertapCustomersLoyalty.createProgramStart();
    }
  }

  render() {
    const { isRewardVisited, isConfigurationVisited } = this.state;
    const isReviewDisabled = this._isReviewDisabled();
    const disabledReviewClass = isReviewDisabled
      ? `${styles['disabled-review-button']} btn-basic`
      : 'btn-primary';
    return (
      <div>
        <PanelGroup activeKey={this.state.activeKey} accordion>
          <WrappedPanel
            title="1. LOYALTY PROGRAM"
            isOpened={this.state.activeKey === '1'}
            isValid={this._programRuleValidity()}
            isVisited
            eventKey={'1'}
            changeActiveKey={this._changeActiveKey}
          >
            <ProgramType
              loyaltySubscription={this.props.loyaltySubscription}
              earningRuleType={this.props.earningRuleType}
              spendingAmount={this.props.spendingAmount}
              pointFromSpendingAmount={this.props.pointFromSpendingAmount}
              itemRules={this._getItemRulesForDisplay(this.props.itemRules)}
              pointFromBuyingItem={this.props.pointFromBuyingItem}
              newMemberPoint={this.props.newMemberPoint}
              setEarningRuleType={this.props.setEarningRuleType}
              setSpendingAmount={this.props.setSpendingAmount}
              setPointFromSpendingAmount={this.props.setPointFromSpendingAmount}
              setItemRules={this.props.setItemRules}
              setPointFromBuyingItem={this.props.setPointFromBuyingItem}
              setNewMemberPoint={this.props.setNewMemberPoint}
              onFinish={this._onFinishProgramType}
            />
          </WrappedPanel>
          <WrappedPanel
            title="2. REWARD"
            isOpened={this.state.activeKey === '2'}
            isValid={this._rewardValidity()}
            isVisited={isRewardVisited}
            eventKey={'2'}
            changeActiveKey={this._changeActiveKey}
          >
            <Reward
              rewards={this.props.rewards}
              addReward={this.props.addReward}
              removeReward={this.props.removeReward}
              removeRewardItem={this.props.removeRewardItem}
              isOpened={this.state.activeKey === '2'}
              onFinish={this._onFinishReward}
              showModalAtFirst={this.state.showModalAtFirst}
              loyaltySubscription={this.props.loyaltySubscription}
            />
          </WrappedPanel>
          <WrappedPanel
            title="3. LOYALTY PROGRAM CONFIGURATION"
            isOpened={this.state.activeKey === '3'}
            isValid={this._configurationValidity()}
            isVisited={isConfigurationVisited}
            eventKey={'3'}
            changeActiveKey={this._changeActiveKey}
          >
            <ProgramConfiguration
              toggleSentValidationCode={this.props.toggleSentValidationCode}
              sentValidationCode={this.props.sentValidationCode}
            />
          </WrappedPanel>
        </PanelGroup>

        <div className="row">
          <div className="col-md-6">
            <button
              onClick={this.props.cancelProgram}
              style={{ color: '#2e79b9' }}
              className={`btn btn-default text-center form-control`}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-6">
            <button
              onClick={this._onClickReview}
              className={`btn text-center form-control ${disabledReviewClass}`}
            >
              Save
            </button>
          </div>
        </div>

        <CannotReviewModal
          show={this.state.showModal}
          close={this._closeModal}
        />
      </div>
    );
  }

  _getItemRulesForDisplay = itemRules => {
    itemRules &&
      itemRules.map(itemRule => {
        if (itemRule.type === 'ITEM_VARIANT') {
          itemRule.type = 'ITEM';
        }
      });
    return itemRules;
  };

  _isReviewDisabled = () => {
    return !(
      this._programRuleValidity() &&
      this._rewardValidity() &&
      this._configurationValidity() &&
      this.state.isRewardVisited &&
      this.state.isConfigurationVisited
    );
  };

  _changeActiveKey = activeKey => {
    // currently only do tracking for create
    if (
      this.props.parentComponent === 'Create' &&
      this.state.activeKey !== activeKey
    ) {
      if (activeKey === '1') {
        clevertapCustomersLoyalty.createProgramStart();
      }
    }

    this.setState({ activeKey });
  };

  _programRuleValidity = () => {
    if (this.props.earningRuleType === 'SPENDING') {
      return (
        this.props.spendingAmount >= 1000 &&
        this.props.pointFromSpendingAmount > 0
      );
    }
    return this._itemRuleValidity();
  };

  _itemRuleValidity = () => {
    const { itemRules } = this.props;
    if (
      itemRules === undefined ||
      itemRules === null ||
      itemRules.length === 0 ||
      this.props.pointFromBuyingItem <= 0 ||
      this.props.pointFromBuyingItem === ''
    ) {
      return false;
    }

    for (let i = 0; i < itemRules.length; i++) {
      const itemRule = itemRules[i];
      if (
        itemRule.type === 'ITEM' &&
        (itemRule.item_name === null ||
          itemRule.item_variant_names === null ||
          itemRule.item_variant_names === undefined ||
          (itemRule.item_variant_names &&
            itemRule.item_variant_names.length === 0))
      ) {
        return false;
      }
    }
    return true;
  };

  _rewardValidity = () => {
    return this.props.rewards.length > 0;
  };

  _configurationValidity = () => {
    return true;
  };

  _onFinishProgramType = () => {
    this.setState({ isRewardVisited: true, activeKey: '2' });
    if (this.props.parentComponent === 'Create') {
      clevertapCustomersLoyalty.createProgramType(this.props);
    }
  };

  _onFinishReward = () => {
    this.setState({ isConfigurationVisited: true, activeKey: '3' });
    if (this.props.parentComponent === 'Create') {
      clevertapCustomersLoyalty.createProgramReward(this.props);
    }
  };

  _closeModal = () => {
    this.setState({
      showModal: false,
    });
  };

  _onClickReview = e => {
    e.stopPropagation();
    if (this._isReviewDisabled()) {
      this.setState({
        showModal: true,
      });
    } else {
      clevertapCustomersLoyalty.createConfiguration(this.props);
      this.setState({ activeKey: '1' });
      this.props.showReview();
    }
  };
}

Program.propTypes = {
  earningRuleType: PropTypes.string.isRequired,
  spendingAmount: PropTypes.number.isRequired,
  pointFromSpendingAmount: PropTypes.number.isRequired,
  pointFromBuyingItem: PropTypes.number.isRequired,
  itemRules: PropTypes.array.isRequired,
  newMemberPoint: PropTypes.number.isRequired,
  setEarningRuleType: PropTypes.func.isRequired,
  setSpendingAmount: PropTypes.func.isRequired,
  setPointFromSpendingAmount: PropTypes.func.isRequired,
  setPointFromBuyingItem: PropTypes.func.isRequired,
  setItemRules: PropTypes.func.isRequired,
  setNewMemberPoint: PropTypes.func.isRequired,
  sentValidationCode: PropTypes.bool.isRequired,
  toggleSentValidationCode: PropTypes.func.isRequired,
  showReview: PropTypes.func.isRequired,
};

export default Program;
